import React, { Component } from 'react';
import Page from '../pages/Page';
import AboutContainer from '../containers/About';
import { injectIntl } from 'react-intl';

class About extends Component {
  getMetaData() {
    return {
      title: this.pageTitle(),
      meta: this.pageMeta(),
      link: this.pageLink()
    };
  }

  pageTitle = () => {
    return this.props.intl.formatMessage({
      id: "brand.about"
    });
  };

  pageMeta = () => {
    return [
      {
        name: 'description', content: this.props.intl.formatMessage({
          id: "brand.about2"
        })
      }
    ];
  };

  pageLink = () => {
    return [];
  };

  render() {
    return (
      <Page {...this.getMetaData() }>
        <AboutContainer {...this.props} />
      </Page>
    );
  }
}

export default injectIntl(About);



// WEBPACK FOOTER //
// app/pages/About.jsx